import { ConnectionStatus } from "app/webSockets/channels"
import { Action, Types } from "./planningTimeslotsChannel.actions"

export type PlanningTimeslotsChannelPayload = {
  from: string
  to: string
}

export type PlanningTimeslotChannelState = {
  payload: PlanningTimeslotsChannelPayload | undefined
  connected: boolean
  errors: object
  connecting: boolean
  status: ConnectionStatus
}

const initialState: PlanningTimeslotChannelState = {
  payload: undefined,
  connected: false,
  errors: {},
  connecting: false,
  status: "connecting",
}

export default (state = initialState, action: Action): PlanningTimeslotChannelState => {
  switch (action.type) {
    case Types.CONNECT:
      return {
        ...state,
        payload: action.payload,
        connecting: true,
        status: "connecting",
      }

    case Types.CONNECTION_SUCCESS:
      return {
        ...state,
        connected: true,
        connecting: false,
      }

    case Types.CONNECTION_FAILED:
      return {
        ...state,
        errors: action.payload.errors,
        connecting: false,
        connected: false,
      }

    case Types.DISCONNECT:
      return {
        ...state,
        payload: undefined,
        connecting: false,
      }

    case Types.DISCONNECT_SUCCESS:
      return {
        ...state,
        connected: false,
        connecting: false,
      }

    case Types.DISCONNECT_FAILED:
      return {
        ...state,
        errors: action.payload.errors,
        connecting: false,
        connected: false,
      }

    case Types.STATUS:
      return {
        ...state,
        status: action.payload,
      }

    default:
      return state
  }
}
